import { WToolButton, type WToolButtonProps } from "@/components/button/WToolButton.tsx";
import { useLingui } from "@lingui/react/macro";
import type { SetOptional } from "type-fest";

export function DeleteButton(props: SetOptional<Omit<WToolButtonProps, "icon">, "label">) {
    const { t } = useLingui();
    return <WToolButton icon="jp-trash-icon" label={t`Delete`} {...props} />;
}
